"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagHiIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagHiIcon = (0, _mobxReact.observer)(_class = (_FlagHiIcon = /*#__PURE__*/function (_React$Component) {
  function FlagHiIcon() {
    _classCallCheck(this, FlagHiIcon);
    return _callSuper(this, FlagHiIcon, arguments);
  }
  _inherits(FlagHiIcon, _React$Component);
  return _createClass(FlagHiIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 100 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#FF9A30",
        x: "0",
        y: "0",
        width: "100",
        height: "33.3"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#FFFFFF",
        x: "0",
        y: "33.3",
        width: "100",
        height: "33.3"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#0A8901",
        x: "0",
        y: "66.7",
        width: "100",
        height: "33.3"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(35.000000, 35.000000)",
        fill: "#000089"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        cx: "14.9",
        cy: "15",
        r: "2.5"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "14.9 12.5 14.4 9.9 14.9 2.7 15.4 10.1"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        cx: "16.6",
        cy: "2.7",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "14.9 12.5 14.4 9.9 14.9 2.7 15.4 10.1"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        cx: "16.6",
        cy: "2.7",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "15.6 12.6 15.8 10 18.1 3.2 16.7 10.4"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(19.814080, 3.533860) rotate(-75.000671) translate(-19.814080, -3.533860) ",
        cx: "19.81408",
        cy: "3.53386",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "16.3 12.9 17.1 10.4 21.1 4.4 17.9 11"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(22.521000, 5.221100) rotate(-59.999272) translate(-22.521000, -5.221100) ",
        cx: "22.521",
        cy: "5.2211",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "16.8 13.3 18.3 11.1 23.7 6.3 18.9 11.9"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(24.869530, 7.422650) rotate(-45.000000) translate(-24.869530, -7.422650) ",
        cx: "24.86953",
        cy: "7.42265",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "17.2 13.8 19.2 12.1 25.6 8.9 19.5 13"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(26.513500, 10.319300) rotate(-30.000728) translate(-26.513500, -10.319300) ",
        cx: "26.5135",
        cy: "10.3193",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "17.5 14.4 19.8 13.2 26.9 11.8 19.9 14.2"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(27.306690, 13.408920) rotate(-14.999329) translate(-27.306690, -13.408920) ",
        cx: "27.30669",
        cy: "13.40892",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "17.5 15.1 20.1 14.6 27.3 15 20 15.6"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        cx: "27.3",
        cy: "16.7",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "17.5 15.7 20.1 15.9 26.9 18.2 19.7 16.8"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(26.541020, 19.769390) rotate(-75.000671) translate(-26.541020, -19.769390) ",
        cx: "26.54102",
        cy: "19.76939",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "17.2 16.4 19.7 17.2 25.7 21.2 19 18"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(24.784600, 22.548200) rotate(-59.999272) translate(-24.784600, -22.548200) ",
        cx: "24.7846",
        cy: "22.5482",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "16.8 16.9 19 18.4 23.7 23.8 18.1 19"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(22.571050, 24.927730) rotate(-45.000000) translate(-22.571050, -24.927730) ",
        cx: "22.57105",
        cy: "24.92773",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "16.2 17.3 18 19.3 21.2 25.8 17 19.6"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(19.788100, 26.578300) rotate(-30.000728) translate(-19.788100, -26.578300) ",
        cx: "19.7881",
        cy: "26.5783",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "15.6 17.6 16.8 19.9 18.2 27 15.8 20"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(16.609460, 27.406480) rotate(-14.999329) translate(-16.609460, -27.406480) ",
        cx: "16.60946",
        cy: "27.40648",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "14.9 17.7 15.4 20.3 15 27.5 14.4 20.1"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        cx: "13.3",
        cy: "27.5",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "14.3 17.6 14.1 20.2 11.8 27 13.1 19.8"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(10.159610, 26.510620) rotate(-75.000671) translate(-10.159610, -26.510620) ",
        cx: "10.15961",
        cy: "26.51062",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "13.6 17.3 12.7 19.8 8.7 25.8 12 19.2"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(7.342800, 24.998000) rotate(-59.999272) translate(-7.342800, -24.998000) ",
        cx: "7.3428",
        cy: "24.998",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "13.1 16.9 11.6 19.1 6.2 23.9 11 18.3"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(5.014170, 22.710370) rotate(-45.000000) translate(-5.014170, -22.710370) ",
        cx: "5.01417",
        cy: "22.71037",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "12.7 16.4 10.6 18.1 4.2 21.3 10.3 17.2"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(3.502100, 19.875800) rotate(-30.000728) translate(-3.502100, -19.875800) ",
        cx: "3.5021",
        cy: "19.8758",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "12.4 15.7 10 16.9 3 18.3 9.9 15.9"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(2.506110, 16.709730) rotate(-14.999329) translate(-2.506110, -16.709730) ",
        cx: "2.50611",
        cy: "16.70973",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "12.3 15 9.7 15.5 2.5 15.1 9.9 14.5"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        cx: "2.6",
        cy: "13.4",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "12.4 14.3 9.8 14.2 3 11.8 10.2 13.2"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(3.463180, 10.196210) rotate(-75.000671) translate(-3.463180, -10.196210) ",
        cx: "3.46318",
        cy: "10.19621",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "12.7 13.7 10.2 12.8 4.2 8.9 10.8 12.1"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(5.002700, 7.381400) rotate(-59.999272) translate(-5.002700, -7.381400) ",
        cx: "5.0027",
        cy: "7.3814",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "13.1 13.2 10.9 11.7 6.1 6.3 11.7 11.1"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(7.294640, 5.099880) rotate(-45.000000) translate(-7.294640, -5.099880) ",
        cx: "7.29464",
        cy: "5.09988",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "13.6 12.8 11.9 10.8 8.7 4.3 12.8 10.5"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(10.097700, 3.521500) rotate(-30.000728) translate(-10.097700, -3.521500) ",
        cx: "10.0977",
        cy: "3.5215",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "14.2 12.5 13.1 10.1 11.7 3.1 14.1 10.1"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        transform: "translate(13.407620, 2.685910) rotate(-14.999329) translate(-13.407620, -2.685910) ",
        cx: "13.40762",
        cy: "2.68591",
        r: "1"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M15,2.5 C21.9,2.5 27.5,8.1 27.5,15 C27.5,21.9 21.9,27.5 15,27.5 C8.1,27.5 2.5,21.9 2.5,15 C2.5,8.1 8.1,2.5 15,2.5 M15,0.5 C7,0.5 0.5,7 0.5,15 C0.5,23 7,29.5 15,29.5 C23,29.5 29.5,23 29.5,15 C29.5,7 23,0.5 15,0.5 L15,0.5 Z",
        id: "Shape"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagHiIcon.defaultProps = {
  width: '20px'
}, _FlagHiIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagHiIcon);